import { useApolloClient } from '@apollo/client';
import { HirerNotificationPreferenceProvider } from '@seek/hirer-notification-preference';
import { useTranslations } from '@vocab/react';
import { Dialog, useToast } from 'braid-design-system';
import type React from 'react';

import type { Job } from 'src/types';

import translations from './.vocab';
import { NotificationPreferenceForm } from './NotificationPreferenceForm';

interface Props {
  seekAdvertiserId: string;
  userId: string;
  email: string;
  job: Job;
  open: boolean;
  onClose(): void;
}

export const NotificationPreferenceDialog: React.FC<
  React.PropsWithChildren<Props>
> = ({ seekAdvertiserId, userId, email, job, open, onClose }: Props) => {
  const { jobId, title } = job;
  const client = useApolloClient();
  const showToast = useToast();
  const { t } = useTranslations(translations);
  const onUpdateSuccess = () => {
    onClose();
    showToast({
      tone: 'positive',
      message: t('Email notifications updated'),
    });
  };

  const DIALOG_TITLE = t('Select how frequently we notify...', {
    title: `'${title}'`,
  });
  return (
    <Dialog
      id={`${jobId}-user-preferences`}
      title={DIALOG_TITLE}
      open={open}
      onClose={onClose}
    >
      <HirerNotificationPreferenceProvider
        jobId={`${jobId}`}
        seekAdvertiserId={`${seekAdvertiserId}`}
        currentLoginUserId={`${userId}`}
        currentLoginUserEmail={`${email}`}
        apolloClient={client}
      >
        <NotificationPreferenceForm
          onSubmitSuccess={onUpdateSuccess}
          onCancel={onClose}
        />
      </HirerNotificationPreferenceProvider>
    </Dialog>
  );
};
